import * as React from 'react'
import { connect } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar'
import Slide from '@material-ui/core/Slide'
import { closeSnackbar } from '../core/duck/actions'


function TransitionUp(props: any) {
  return <Slide {...props} direction="up" />
}

interface IProps {
  open: boolean
  message: string
  closeSnackbar: () => void
}

interface IState {
  Transition: any
  open: boolean
}

class DirectionSnackbar extends React.Component<IProps, IState> {
  public state = {
    open: false,
    Transition: null
  }

  public componentDidUpdate(prevProps: any) {
    /**
     * Because the snackbar is used throughout app and not
     * limited to one screen, have to handle state a bit differently,
     * hence the code below.
     */
    if (this.props.open === true && prevProps.open === false) {
      this.setState({ open: true, Transition: TransitionUp })
      setTimeout(() => {
        this.props.closeSnackbar()
      }, 1200)
    } else if (this.props.open === false && prevProps.open === true) {
      this.handleClose()
    }
  }

  public handleClose = () => {
    this.setState({ open: false })
  }

  public render() {
    return (
      <div>
        <Snackbar
          open={this.state.open}
          onClose={this.handleClose}
          // @ts-ignore
          TransitionComponent={this.state.Transition}
          message={<span id="message-id">{this.props.message}</span>}
          style={{ left: '15%', right: 'auto' }}
        />
      </div>
    )
  }
}

const mapStateToProps = (state: any) => ({
  message: state.snackbar.message,
  open: state.snackbar.open
})
export default connect(
  mapStateToProps,
  { closeSnackbar }
)(DirectionSnackbar)



// WEBPACK FOOTER //
// ./src/shared/Snackbar.tsx